module.exports = __webpack_public_path__ + "./fonts/downArrow.c5355918d8b74a9a609d7cc6200dd28d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/downArrow.svg
// module id = ./assets/images/downArrow.svg
// module chunks = 0